import React from 'react';
import PropTypes from 'prop-types';
import { manualUserVenuesPropTypes, msiLastChangePropTypes } from 'constants/propTypes';
import { defineMessages } from 'react-intl';
import { formatPhoneNumberIntl } from 'react-phone-number-input';
import _isEmpty from 'lodash/isEmpty';

import Message from 'components/Message';
import LastUpdate from 'components/LastUpdate';
import SvgInstagramLogo from 'components/Svgs/SocialMedia/InstagramLogo';

const messages = defineMessages({
  email: {
    id: 'instructor-details.description.email',
    defaultMessage: 'Email Address',
  },
  bio: {
    id: 'instructor-details.description.bio',
    defaultMessage: 'Bio',
  },
  locations: {
    id: 'instructor-details.description.locations',
    defaultMessage: 'Locations',
  },
  phoneNumber: {
    id: 'instructor-details.description.phone-number',
    defaultMessage: 'Phone Number',
  },
  certifications: {
    id: 'instructor-details.description.certifications',
    defaultMessage: 'Certifications / Specialities',
  },
  socialHandles: {
    id: 'instructor-details.description.social-handles',
    defaultMessage: 'Social Handles',
  },
});

const venueLocationsByIds = (venues, instructorVenueIds) =>
  instructorVenueIds.reduce((instructorVenueAddresses, venueId) => {
    const venue = venues.find(item => venueId === item.id);
    return !venue ? instructorVenueAddresses : instructorVenueAddresses.concat(venue);
  }, []);

// TODO(kamil): Simplify this venue passing and rendering
const renderVenues = venueList => !_isEmpty(venueList) && venueList.map(({ name }) => name).join(', ');

const renderInstagramHandle = instagramHandle => {
  const { userName } = instagramHandle;
  if (!userName) return null;

  return (
    <div className="instructor-details__social-icon-box">
      <SvgInstagramLogo className="instructor-details__social-media-icon" />
      {`@${userName}`}
    </div>
  );
};

const InstructorDetailsDescription = ({
  email,
  bio,
  socialHandle,
  phone,
  certifications,
  venues,
  instructorVenueIds,
  lastChange,
}) => (
  <div>
    <div className="grid grid--flush">
      <div className="instructor-details__row grid grid--flush">
        <div className="instructor-details__cell grid__item lg-1/2">
          <Message as="p" message={messages.email} />
          {email || '-'}
        </div>
        <div className="instructor-details__cell grid__item lg-1/2">
          <Message as="p" message={messages.phoneNumber} />
          {phone ? formatPhoneNumberIntl(phone) : '-'}
        </div>
      </div>
      <div className="instructor-details__row grid grid--flush">
        <div className="instructor-details__cell grid__item lg-1/2">
          <Message as="p" message={messages.bio} />
          {bio || '-'}
        </div>
        <div className="instructor-details__cell grid__item lg-1/2">
          <Message as="p" message={messages.certifications} />
          {certifications || '-'}
        </div>
      </div>
      <div className="instructor-details__row grid grid--flush">
        <div className="instructor-details__cell grid__item lg-1/2">
          <Message as="p" message={messages.locations} />
          {renderVenues(venueLocationsByIds(venues, instructorVenueIds))}
        </div>
        <div className="instructor-details__cell grid__item lg-1/2">
          <Message as="p" message={messages.socialHandles} />
          {renderInstagramHandle(socialHandle) || '-'}
        </div>
        <LastUpdate className="instructor-details__cell grid__item lg-1/1" {...lastChange} />
      </div>
    </div>
  </div>
);

InstructorDetailsDescription.propTypes = {
  email: PropTypes.string,
  bio: PropTypes.string,
  socialHandle: PropTypes.shape({
    service: PropTypes.string,
    userName: PropTypes.string,
  }),
  phone: PropTypes.string,
  certifications: PropTypes.string,
  venues: manualUserVenuesPropTypes,
  instructorVenueIds: PropTypes.arrayOf(PropTypes.number),
  lastChange: msiLastChangePropTypes,
};

export default InstructorDetailsDescription;
